import {
  LOAD_CHAT_HISTORY,
  NEW_MESSAGE,
  ERROR_MESSAGE,
  DISCONNECT,
  CONNECT,
} from "../types/chatTypes";

//import { alertError } from "../../utils/feedback";
//import { automaticSignOut } from "../actions/userActionCreators";


const initialState = {
  messages: [],
  error: null,
  isConnected: false,
};



const messageReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CHAT_HISTORY:
      return { ...state, messages: action.payload,};
    case NEW_MESSAGE:
      return {...state,messages: [...state.messages,action.payload]};
    case CONNECT:
      return {...state,isConnected: true};
    case DISCONNECT:
      return {...state,isConnected: false};
    case ERROR_MESSAGE:
      return {...state, error: action.payload}
    default:
      return state;
  }
};

export default messageReducer;
